export const PolkaGate = () => (
  <svg
    data-name="PolkaGate"
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 128 128"
  >
    <circle cx="64" cy="64" r="64" />
    <path
      d="M106.34 28.67a27.44 27.44 0 00-8.2-4.78 46 46 0 00-15.61-2.82 76 76 0 00-22.48 3.1 55 55 0 00-9.8 3.5l-.16.07a62.5 62.5 0 0113.47-1.24A39.59 39.59 0 0177 28.93a23.67 23.67 0 017.07 4.12 17.05 17.05 0 016.17 13.43A26.43 26.43 0 0186.83 59a51.08 51.08 0 01-11.76 14.42 78.89 78.89 0 01-22.91 14 73.11 73.11 0 01-24.53 5.48 44.63 44.63 0 01-13.14-1.25 29.41 29.41 0 008.82 4.4 50.59 50.59 0 0017.51 2.1 84.75 84.75 0 0028.47-6.4 91.72 91.72 0 0026.59-16.21 59.26 59.26 0 0013.66-16.76 30.81 30.81 0 004-14.52 19.79 19.79 0 00-7.2-15.59z"
      fill="#e30b7b"
    />
    <path
      d="M65.56 80.54c1-.66 2-1.34 3-2-1.69-.4-3.44-.86-5-1.33-4.76-1.47-3.17-7.82-2-9.38a68.72 68.72 0 007.14-13.4c1.49-4.1.19-9.22-.49-11.36-.12-.33-.24-.67-.34-1l-1.84-5.56a19.56 19.56 0 00-2.53-4.67 7.58 7.58 0 00-6-3.14 16.22 16.22 0 00-3.74.33c-2 .32-4 .68-6 1a1 1 0 01-.21 0c.48.61.9 1.14 1.3 1.67.59.8 1.17 1.62 1.77 2.42A8.63 8.63 0 0152.34 39a17.49 17.49 0 01-.24 3.32 70.31 70.31 0 00-5.45 8.89L31.74 80.62a1.34 1.34 0 00-.07.18l.06.06 5-3 .06.07q-8.03 12.87-16.08 25.74h.05L23 102.4c-.63 1.54-1.22 3-1.84 4.54A9.49 9.49 0 0024 105.4a7.82 7.82 0 002.1-2.49l.42.71.29-.35c3.73-4.73 7.59-9.36 11.63-13.84a107.25 107.25 0 019.77-9.77A23.36 23.36 0 0153 76.35a5.4 5.4 0 012-.59l-2.59 2.79c1.88-1 2.15-.31 4-1.27l.21.22c1.62 1.92 5.27 2.6 7.77 2.82a7.53 7.53 0 011.17.22z"
      fill="#fff"
    />
  </svg>
);

export default PolkaGate;
